import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Divider,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { allIcons } from "../../assets";
import AdminChat from "./AdminChat";
import AllWorkers from "./AllWorkers";
import { t } from "i18next";

const style = {
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "#F3F3F3",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `none`,
        boxShadow: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
    },
  },
};

function AllUsers({ socket }) {
  return (
    <Paper sx={{ borderRadius: "10px" }}>
      <Stack gap={1.5} p={2} direction={"row"} alignItems={"center"}>
        <img
          src={allIcons.handshakeInactiveIcon}
          alt="handshake-icon"
          width={30}
        />
        <Stack direction={"row"} alignItems={"center"}>
          <Typography variant="h1" fontSize={"1.125rem"} fontWeight={"bold"}>
            {t("messages")}
          </Typography>
          <ExpandMoreIcon />
        </Stack>
      </Stack>

      <Divider />

      <Box m={1}>
        <TextField
          variant="outlined"
          sx={style.searchField}
          fullWidth
          placeholder={t("searchMessage")}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Stack p={1} gap={1.5}>
        <AdminChat socket={socket} />
        <Typography variant="h1" fontSize={"1.125rem"} fontWeight={"bold"}>
          {t("workers")}
        </Typography>
        <AllWorkers socket={socket} />
      </Stack>
    </Paper>
  );
}

export default AllUsers;
